import { createElement, type FunctionComponent } from 'react'
import { type FormikProps } from 'formik'
import { type ReportFilterDefinitionsInterface } from '__codegen__/api'
import {
  generatedReportsFilterComponentMapping,
  generatedReportsFilterComponentFormikPropsMapping,
  generatedReportsFilterComponentPropsMapping,
} from 'legacy/sections/generated-reports/components/add/components/form/filters/utils/generatedReportsAddFormFilters.utils'
import { type GeneratedReportsAddFormValues } from 'legacy/sections/generated-reports/components/add/components/form/utils/generatedReportsAddForm.types'

interface Props {
  filter: ReportFilterDefinitionsInterface
  formikProps: FormikProps<GeneratedReportsAddFormValues>
}

export const GeneratedReportsAddFormFilter: FunctionComponent<Props> = ({
  filter,
  formikProps,
}) => {
  const resolvedComponent = generatedReportsFilterComponentMapping(filter)
  const resolvedProps = generatedReportsFilterComponentPropsMapping(filter)
  const resolvedFormikProps = generatedReportsFilterComponentFormikPropsMapping(filter, formikProps)

  if (!resolvedComponent) return null

  return createElement(resolvedComponent, { ...resolvedProps, ...resolvedFormikProps }, null)
}
